import { useUserStore } from "~/store/userStore";

export default defineNuxtRouteMiddleware((to, from) => {
    const userStore = useUserStore();

    if (from.query.enter == "true") {
        to.meta.pageTransition.name = "slide-right";
    }
    else to.meta.pageTransition.name = "slide-left";
});